import { Col, Flex, message, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  deleteRuleById,
  fetchRuleById,
} from "../../../lib/api/resources/rules";
import { RuleDetailCard } from "./components/RuleDetailCard";

export const RuleDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) return null;

  const { data, isLoading } = useQuery({
    queryKey: ["rule", id],
    queryFn: () => fetchRuleById(id),
  });

  const deleteRuleMutation = useMutation({
    mutationFn: () => deleteRuleById(id),
    onSuccess: () => {
      navigate(`/rules`);
      message.success("Rule succesvol verwijderd");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het verwijderen van de rule",
      ),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <RuleDetailCard
              deleteMutation={deleteRuleMutation}
              rule={data}
              isLoading={isLoading}
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
